<template id="checkbox-template">
  <label class="checkbox" >
    <input type="checkbox"
      :value="value"
      :checked="state"
      @change="onChange"
    />
    <i>
     <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" preserveAspectRatio="xMidYMid" width="16" height="12" viewBox="0 0 16 12" class="svg">
       <g fill="#ff6659">
           <path d="M15.686,1.730 L6.747,11.683 C6.537,11.893 6.260,11.985 5.986,11.974 C5.711,11.985 5.434,11.893 5.224,11.683 L0.285,6.731 C-0.114,6.331 -0.114,5.684 0.285,5.285 C0.684,4.885 1.330,4.885 1.728,5.285 L5.950,9.517 L14.242,0.285 C14.641,-0.115 15.287,-0.115 15.686,0.285 C16.085,0.684 16.085,1.331 15.686,1.730 Z"/>
       </g>
     </svg>
    </i>
    <span>{{ label }}</span>
    </label>
</template>

<script>
export default {
  name: 'checkbox',
  model: {
    prop: 'modelValue',
    event: 'input'
  },
  props: {
    checked: {
      type: Boolean,
      default: false,
    },
    value: {
      default: null,
    },
    label: {
      default: null,
    },
    modelValue: {
      type: [Array, Object, String, Boolean],
      default: undefined,
    },
    // model: {}
  },
  computed: {
    state() {
      if (this.modelValue === undefined) {
        return this.checked;
      }
      if (Array.isArray(this.modelValue)) {
        return this.modelValue.indexOf(this.value) > -1;
      }
      return !!this.modelValue;
    }
  },
  methods: {
    onChange() {
      this.toggle();
    },
    toggle() {
      let value;
      if (Array.isArray(this.modelValue)) {
        value = this.modelValue.slice(0);
        console.log("toggle value", value);
        if (this.state) {
          value.splice(value.indexOf(this.value), 1);
        } else {
          value.push(this.value);
        }
      } else {
        value = !this.state;
      }
      this.$emit('input', value);
    }
  },
  watch: {
    checked(newValue) {
      if (newValue !== this.state) {
        console.log("toggle checked", newValue);
        this.toggle();
      }
    }
  },
  mounted() {
    if (this.checked && !this.state) {
      this.toggle();
    }
  }
}


</script>

<style>
  label.checkbox i .svg g{
    fill: #ff6659;
  }
</style>



// WEBPACK FOOTER //
// src/components/checkbox.vue